

export const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_ICLOUD_SERVICE_ID
export const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID
export const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY

